var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodescreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 110,
    viewBox: "0 0 130 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3865,
    cy: 54.614,
    r: 54.614,
    fill: "#C4ABD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.4076 37.6034C-7.80641 42.6785 -0.472934 13.763 0.467536 96.2979C0.467536 101.898 5.02206 106.454 10.6208 106.454C112.833 101.379 105.5 130.293 104.559 47.7599C104.559 42.1595 100.005 37.6034 94.4061 37.6034H94.4076ZM2.69132 46.9641C3.02159 42.9962 6.63878 39.7203 10.6208 39.7879C10.6224 39.7879 94.4061 39.7879 94.4061 39.7879C98.8898 39.5803 104.048 44.7592 101.609 49.1533C70.6946 50.509 39.0394 49.1643 7.8875 49.6251C5.79739 49.6487 2.20222 50.1237 2.69132 46.9641ZM102.376 55.4205C102.376 69.0463 102.376 82.6721 102.376 96.2995C102.376 100.694 98.8018 104.268 94.4076 104.268H10.6208C3.61135 104.13 2.02293 97.6206 2.65201 91.7639C2.65201 80.1149 2.65201 68.4644 2.65201 56.8155C2.63628 54.5948 2.17076 51.3032 5.46713 51.8112C32.0032 51.8112 58.5408 51.8112 85.0784 51.8112C89.2932 52.8885 103.809 48.7586 102.376 55.4221V55.4205Z",
    fill: "#6B2C90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9944 88.6563C33.5207 78.8773 29.4364 81.4188 40.1936 70.7591C40.8762 69.7604 43.0811 68.6815 41.933 67.3416C41.4942 66.9264 40.8038 66.9437 40.3871 67.3809C40.1747 68.2538 28.1877 78.5958 30.1944 79.6322L40.4861 90.24C41.5037 91.3 43.1047 89.6298 41.9944 88.6563Z",
    fill: "#6B2C90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7245 68.4739C56.9305 67.3824 71.2216 77.465 70.4588 80.0017C71.5723 82.3686 56.6993 92.1319 63.6255 91.333C77.1931 76.8139 77.0295 83.0905 63.7245 68.4739Z",
    fill: "#6B2C90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0711 64.4443C57.4087 62.3086 45.1905 93.2419 44.5063 93.3929C44.2547 93.9418 44.4938 94.5913 45.0411 94.8445C46.6751 97.0227 58.939 66.0233 59.6058 65.8959C59.8574 65.3471 59.6184 64.6975 59.0711 64.4443Z",
    fill: "#6B2C90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3281 48.8041C79.631 48.9064 79.631 41.5981 75.3281 41.7003C71.0268 41.5981 71.0253 48.9064 75.3281 48.8041ZM75.3281 43.6127C77.1477 43.1063 77.2437 47.1135 75.3281 46.8917C72.793 46.5442 73.5164 43.825 75.3281 43.6127Z",
    fill: "#6B2C90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6612 48.8043C88.3054 48.7791 88.3054 41.724 83.6612 41.7004C78.594 41.5227 79.2986 48.8924 83.6612 48.8043ZM84.0717 43.6128C85.8819 43.855 86.404 46.7928 83.6612 46.6182C81.4139 46.7661 82.0964 43.1835 84.0717 43.6128Z",
    fill: "#6B2C90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9937 48.8041C96.3076 48.9598 96.8611 41.8386 92.2673 41.9738C87.3809 41.8323 87.2551 48.6704 91.9937 48.8041ZM91.9937 43.6126C95.5668 43.4443 94.079 47.6261 91.9937 46.8917C89.5277 46.5016 89.5292 44.0026 91.9937 43.6126Z",
    fill: "#6B2C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodescreen);
export default __webpack_public_path__ + "static/media/codescreen.8b18e88b5b70c75b56d0697dab74d330.svg";
export { ForwardRef as ReactComponent };